<template>
  <van-popup
    class="modify-price-modal"
    :close-on-click-overlay="false"
    :value="show"
    closeable
    @input="onUpdateShow"
  >
    <div>
      <div class="inner">
        <div class="adjust-title">
          调价之后需要进行审核，<br />确认调整价格？
        </div>
        <div class="order-cell-container">
          <OrderItemCard is-simple :data="data.data" :is-last="true" />
        </div>
        <div class="inner-form">
          <div class="mb10 inner-form-first">
            <label class="label" for="modifyPrice"
              ><span class="required">调整后价格</span></label
            >
            <div class="text-input price-icon-input" id="modifyPrice">
              <input
                type="text"
                :value="modifyPrice"
                @input="onNewPriceInput"
                class="input bolder"
                placeholder="请输入价格"
              />
            </div>
          </div>
          <div>
            <label class="label" for="changeRemark">
              <span class="required">调价原因</span>
            </label>
            <div class="text-input" id="changeRemark">
              <input
                type="text"
                v-model="changeRemark"
                class="input"
                placeholder="请输入备注"
              />
            </div>
          </div>
        </div>
        <div class="change-price-operation c:row-between-center">
          <van-button
            class="c:flex-1"
            @click.prevent="() => onUpdateShow(false)"
            >取消</van-button
          >
          <van-button
            class="c:flex-1"
            :disabled="!modifyPrice || !changeRemark || modifyPrice <= 0"
            type="primary"
            @click.prevent="submitNewPrice"
            >确定</van-button
          >
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import OrderItemCard from "../order/widgets/OrderItemCard.vue";
export default {
  name: "AdjustPricePopup",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    defaultPrice: {
      type: String,
      default: "",
    },
    defaultRemark: {
      type: String,
      default: "",
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { OrderItemCard },
  data() {
    return {
      modifyPrice: "",
      changeRemark: "",
    };
  },
  watch: {
    show(value) {
      if (value) {
        this.initModal();
      }
    },
  },
  methods: {
    onUpdateShow(value) {
      this.$emit("update:show", value);
    },
    initModal() {
      this.modifyPrice = this.defaultPrice || "";
      this.changeRemark = this.defaultRemark || "";
    },
    onNewPriceInput(e) {
      const value = e.target.value;
      if (
        /^$|^(0(\.\d{0,2})?|[1-9]\d*(\.\d{0,2})?|\.\d{0,2})$/.test(value) ||
        value == ""
      ) {
        this.modifyPrice = value;
      } else {
        e.target.value = this.modifyPrice || "";
      }
    },
    submitNewPrice() {
      this.$emit("submit", {
        modifyPrice: String(parseFloat(this.modifyPrice)),
        changeRemark: this.changeRemark,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.modify-price-modal {
  width: 320/20rem;
  min-height: 15rem;
  border-radius: 10px;

  .inner {
    padding-top: 50/20rem;

    h2 {
      text-align: center;
      color: @text-color;
      font-size: 16px;
      line-height: 1.5em;
    }

    .inner-form {
      padding: 0 0.9rem;
      .inner-form-first {
        border-top: 1px solid #e4e4e4;
        padding-top: 1rem;
      }
    }
  }

  .text-input {
    input {
      color: @text-color;
    }
  }

  .disabled {
    color: #ccc;
    pointer-events: none;
  }
}
.price-icon-input {
  position: relative;
  &::before {
    content: "￥";
    position: absolute;
    top: 13/20rem;
    left: 8/20rem;
    font-size: 14px;
  }
  input {
    padding-left: 24/20rem;
  }
}

.order-cell-container {
  padding: 0 20/20rem;
}
.change-price-operation {
  width: 100%;
  padding: 18/20rem;
  gap: 16/20rem;
}
.adjust-title {
  font-weight: normal;
  text-align: center;
  font-size: 15px;
}
</style>
